__turbopack_context__.v({
  "chartContainer": "InterestTableRowGraph-module-scss-module__Ekgr7a__chartContainer",
  "date": "InterestTableRowGraph-module-scss-module__Ekgr7a__date",
  "percentage": "InterestTableRowGraph-module-scss-module__Ekgr7a__percentage",
  "tooltipContainer": "InterestTableRowGraph-module-scss-module__Ekgr7a__tooltipContainer",
});
